import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { createPublicApi } from '../../services/api';
import NotFound404 from '../../pages/NotFound404';

/**
 * SlugValidator
 * Wraps any public restaurant page.
 * - Calls /r/:slug/settings to verify the restaurant exists.
 * - Shows a spinner while checking.
 * - Renders children if valid, 404 page if not.
 */
export default function SlugValidator({ children }) {
  const { slug } = useParams();
  const [status, setStatus] = useState('loading'); // 'loading' | 'valid' | 'invalid'

  useEffect(() => {
    if (!slug) { setStatus('invalid'); return; }

    const api = createPublicApi(slug);
    api.settings.get()
      .then(() => setStatus('valid'))
      .catch((err) => {
        // 404 = restaurant not found, anything else also treat as invalid
        setStatus('invalid');
      });
  }, [slug]);

  if (status === 'loading') return <LoadingScreen />;
  if (status === 'invalid') return <NotFound404 />;
  return children;
}

/* ── Minimal loading screen ──────────────────────────────────────────── */
function LoadingScreen() {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(160deg, #0D0400, #1C0A00)',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', gap: 20,
    }}>
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes pulse {
          0%,100% { opacity:1; transform:scale(1); }
          50%      { opacity:0.5; transform:scale(0.9); }
        }
      `}</style>

      {/* Spinner */}
      <div style={{
        width: 52, height: 52, borderRadius: '50%',
        border: '3px solid rgba(232,96,10,0.15)',
        borderTopColor: '#E8600A',
        animation: 'spin 0.9s linear infinite',
      }} />

      {/* Logo text */}
      <div style={{
        fontFamily: 'Georgia, serif', fontSize: 18, fontWeight: 700,
        color: 'rgba(255,255,255,0.5)', animation: 'pulse 2s ease-in-out infinite',
      }}>
        Swad<span style={{ color: '#F5A623' }}>Zone</span>
      </div>
    </div>
  );
}
